<template>
  <div class="profile" v-if="data">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
    >
      <v-tab>Datos básicos</v-tab>
      <v-tab>Aprobaciones</v-tab>
      <v-tab>Supervisores</v-tab>
      <v-tab>
        <v-badge
          color="green"
          :content="data.notes.length > 0 ? data.notes.length : '0'"
        >
          Notas
        </v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card>
          <v-card-text v-if="showMain">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title class="primary white--text">
                    Información Principal
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-row class="text-left">
                      <v-col cols="12" md="4">
                        <span class="black--text font-weight-bold"
                          ># Informe:</span
                        >
                        {{ data.reference }}
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="black--text font-weight-bold"
                          >Periodo Inicio:</span
                        >
                        {{ data.period_start_date }}
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="black--text font-weight-bold"
                          >Periodo Finalización:</span
                        >
                        {{ data.period_end_date }}
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="black--text font-weight-bold"
                          >Colaborador:</span
                        >
                        {{ data.contract.employee.user.full_name }}
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="black--text font-weight-bold"
                          ># Contrato:</span
                        >
                        {{ data.contract.reference }}
                      </v-col>

                      <v-col cols="12" md="12" v-if="data.activitiesText">
                        <span class="black--text font-weight-bold"
                          >Actividades:</span
                        >
                        <br />
                        {{ data.activitiesText }}
                      </v-col>

                      <v-col cols="12" md="12" v-if="data.conclusions">
                        <span class="black--text font-weight-bold"
                          >Conclusiones:</span
                        >
                        <br />
                        {{ data.conclusions }}
                      </v-col>

                      <v-col cols="12" md="3">
                        <v-chip
                          :color="getReportStatuColor(data.status)"
                          dark
                          small
                        >
                          {{ getReportStatus(data.status) }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" md="3" v-if="data.report_signed_url">
                        <v-btn
                          color="blue"
                          rounded
                          dark
                          :href="data.report_signed_url"
                          target="_blank"
                          small
                        >
                          Informe Firmado
                          <v-icon right dark> mdi-cloud-download </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="!data.report_url && data.status == 'APPROVED'"
                      >
                        <v-btn
                          small
                          color="primary"
                          rounded
                          @click="createReportPdf"
                        >
                          Crear PDF
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="role == 'REVIEWER' && data.status == 'PENDING'"
                    >
                      <v-col cols="12" md="12">
                        <v-btn
                          color="success"
                          dark
                          class="mb-2"
                          @click="dialogApproval = true"
                        >
                          <v-icon left dark> mdi-check </v-icon>
                          Aprobar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="data.activities.length">
              <v-col cols="12">
                <v-card>
                  <v-card-title class="primary white--text">
                    Actividades
                  </v-card-title>
                  <v-card-text class="py-3">
                    <activities-form
                      :model="data"
                      :charge="null"
                      :typeActivity="null"
                      :rules="null"
                      :edit="false"
                    ></activities-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="data.evidences.length">
              <v-col cols="12">
                <v-card>
                  <v-card-title class="primary white--text">
                    Logros
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-row class="text-left">
                      <v-col cols="12" md="12">
                        <span class="black--text font-weight-bold"
                          >Logros Alcanzados:</span
                        >
                        <br />
                        {{ data.achievements }}
                      </v-col>
                      <v-col cols="12" md="12">
                        <evidences :data="data"></evidences>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="data.statistics.length">
              <v-col cols="12">
                <v-card>
                  <v-card-title class="primary white--text">
                    Estadística
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-row class="text-left">
                      <v-col cols="12" md="12">
                        <statistics-form
                          :model="data"
                          :charge="null"
                          :typeStatistics="null"
                          :edit="false"
                        ></statistics-form>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="data.accompaniments.length">
              <v-col cols="12">
                <v-card>
                  <v-card-title class="primary white--text">
                    Acompañamientos
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-row class="text-left">
                      <v-col cols="12" md="12">
                        <accompaniments-form
                          :model="data"
                          :charge="null"
                          :rules="null"
                          :edit="false"
                        ></accompaniments-form>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-tooltip top v-if="data.status == 'APPROVED'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              bottom
              right
              fixed
              color="green"
              v-bind="attrs"
              v-on="on"
              dark
              @click="upload"
            >
              <v-icon>mdi-file-upload</v-icon>
            </v-btn>
          </template>
          <span>Subir documentos</span>
        </v-tooltip>
      </v-tab-item>

      <v-tab-item>
        <approvals :data="data"></approvals>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="headersSupervisors"
              :items="data.contract.supervisors"
              :items-per-page="20"
              no-data-text="No hay registro"
            >
              <template v-slot:[`item.name`]="item">
                {{ item.item.employee.user.full_name }}
              </template>
              <template v-slot:[`item.charge`]="item">
                {{ item.item.employee.charge.name }}
              </template>
              <template v-slot:[`item.type`]="item">
                {{ getSupervisorType(item.item.type) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <note-show
          :notes="data.notes"
          :owner="data.contract.employee.user.id"
          type="REPORT"
          :report="data.id"
        ></note-show>
      </v-tab-item>
    </v-tabs-items>

    <!--  <v-tooltip top v-if="data.status !== 'APPROVED'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          bottom
          right
          fixed
          color="green"
          v-bind="attrs"
          v-on="on"
          dark
          :href="`/contracts/${data.contract.id}/reports/edit/${data.id}`"
        >
          <v-icon> mdi-pencil </v-icon>
        </v-btn>
      </template>
      <span>Editar</span>
    </v-tooltip> -->

    <!-- Dialog upload report signed -->
    <v-dialog v-model="dialogUpload" width="550" persistent>
      <v-card>
        <v-card-title v-if="data">
          Subir Informe Firmado #{{ data.reference }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Informe Firmado"
              v-model="model.report_signed_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- approval dialog -->
    <v-dialog v-model="dialogApproval" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea aprobar este informe?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-4" @click="approve" small>
            Confirmar
          </v-btn>

          <v-btn
            color="error"
            text
            class="mr-4"
            @click="dialogApproval = false"
            small
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog loader -->
    <v-dialog
      v-model="this.$store.state.report.isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_REPORT } from "@/store/report";
import { SET_ALERT } from "@/store/alert";
import NoteShow from "@/components/note/Show";
import Evidences from "@/components/report/Evidences";
import Approvals from "@/components/report/Approvals";
import ActivitiesForm from "@/components/report/create/Activities";
import StatisticsForm from "@/components/report/create/Statistics";
import AccompanimentsForm from "@/components/report/create/Accompaniments";
export default {
  name: "ShowEmployee",
  props: ["id"],
  components: {
    NoteShow,
    Evidences,
    Approvals,
    ActivitiesForm,
    StatisticsForm,
    AccompanimentsForm,
  },
  data: () => ({
    tab: null,
    data: null,
    showMain: false,
    formUpload: true,
    dialogUpload: false,
    dialogApproval: false,
    model: {
      report_signed_file: null,
    },
    headersSupervisors: [
      {
        text: "Nombre",
        value: "name",
        sortable: true,
      },
      {
        text: "Cargo",
        value: "charge",
        filterable: false,
        sortable: false,
      },
      {
        text: "Tipo",
        value: "type",
        filterable: false,
        sortable: false,
      },
    ],
  }),
  created() {
    this.$store.dispatch("getReport", this.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_REPORT) {
        this.data = state.report.report;
        this.data.activitiesText = this.data.activities;
        this.data.activities = this.data.activities_array;        
        this.showMain = true;
      }
    });
  },
  computed: {
    ...mapGetters([
      "getReportStatuColor",
      "getReportStatus",
      "getSupervisorType",
    ]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
  },
  methods: {
    approve() {
      this.$store.dispatch("updateReport", {
        id: this.id,
        form: {
          user_id: this.$store.state.user.user.id,
        },
      });
      this.dialogApproval = false;
    },
    upload() {
      this.dialogUpload = true;
    },
    cancelUpload() {
      this.dialogUpload = false;
      this.model = {
        support_file: null,
        payroll_file: null,
      };
    },
    saveUpload() {
      if (this.model.report_signed_file == null) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar los archivos",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateReport", {
        id: this.data.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
    createReportPdf() {
      this.$store.dispatch("createReportPdf", {
        id: this.data.id,
      });
    },
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
